export const FEATURE_ENTITLEMENTS_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed'
} as const;

export type TFeatureEntitlementsStatus =
  (typeof FEATURE_ENTITLEMENTS_STATUS)[keyof typeof FEATURE_ENTITLEMENTS_STATUS];
